import {
  GET_EXPENSE_VENDORS_REQUEST,
  GET_EXPENSE_VENDORS_SUCCESS,
  GET_EXPENSE_VENDORS_FAILURE,
  GET_EXPENSE_VENDOR_REQUEST,
  GET_EXPENSE_VENDOR_SUCCESS,
  GET_EXPENSE_VENDOR_FAILURE,
  CREATE_EXPENSE_VENDOR_REQUEST,
  CREATE_EXPENSE_VENDOR_SUCCESS,
  CREATE_EXPENSE_VENDOR_FAILURE,
  UPDATE_EXPENSE_VENDOR_REQUEST,
  UPDATE_EXPENSE_VENDOR_SUCCESS,
  UPDATE_EXPENSE_VENDOR_FAILURE,
  DELETE_EXPENSE_VENDOR_REQUEST,
  DELETE_EXPENSE_VENDOR_SUCCESS,
  DELETE_EXPENSE_VENDOR_FAILURE
} from '../types';

const initialState = {
  vendors: [],
  currentVendor: null,
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10
  }
};

const expenseVendorReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Expense Vendors
    case GET_EXPENSE_VENDORS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_EXPENSE_VENDORS_SUCCESS:
      return {
        ...state,
        loading: false,
        vendors: action.payload.data.vendors,
        pagination: action.payload.data.pagination,
        error: null
      };

    case GET_EXPENSE_VENDORS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Get Single Expense Vendor
    case GET_EXPENSE_VENDOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_EXPENSE_VENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        currentVendor: action.payload.data,
        error: null
      };

    case GET_EXPENSE_VENDOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Create Expense Vendor
    case CREATE_EXPENSE_VENDOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case CREATE_EXPENSE_VENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        vendors: [action.payload.data, ...state.vendors],
        error: null
      };

    case CREATE_EXPENSE_VENDOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Update Expense Vendor
    case UPDATE_EXPENSE_VENDOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case UPDATE_EXPENSE_VENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        vendors: state.vendors.map(vendor =>
          vendor.id === action.payload.data.id ? action.payload.data : vendor
        ),
        currentVendor: state.currentVendor?.id === action.payload.data.id 
          ? action.payload.data 
          : state.currentVendor,
        error: null
      };

    case UPDATE_EXPENSE_VENDOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Delete Expense Vendor
    case DELETE_EXPENSE_VENDOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case DELETE_EXPENSE_VENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        vendors: state.vendors.filter(vendor => vendor.id !== action.payload.id),
        currentVendor: state.currentVendor?.id === action.payload.id 
          ? null 
          : state.currentVendor,
        error: null
      };

    case DELETE_EXPENSE_VENDOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default expenseVendorReducer;
